<template>
  <div class="image-choice-content">
    <div
      class="box-chart"
      :class="{'chart-white': $store.state.slideActive.textColour == '#ffffff'}"
      v-show="_isShowChart()"
    >
      <div class="vertical layout content-chart" :class="'column-' + options.length">
        <div class="flex bar-column horizontal layout">
          <div
            v-for="(item, index) in options"
            :key="index"
            class="flex column-option horizontal layout end"
            @click="_showChartPercentage()"
            v-show="item.countPercent"
          >
            <div
              class="h-column"
              :style="{height: item.countPercent, opacity: opacityWhenHoverColumn(item.title)}"
              @mouseover="mouseoverColumn(item.title)"
              @mouseleave="mouseLeaveColumn"
            >
              <div class="value-column">
                <span v-if="!$store.state.slideActive.showPercentage">{{ item.count || 0 }}</span>
                <span v-if="$store.state.slideActive.showPercentage">{{ item.percent }}%</span>
              </div>
              <div
                class="content-column"
                :style="{backgroundColor: item.color}"
                :class="{'no-border': !item.count}"
              />
            </div>
          </div>
        </div>
        <div class="line" />
        <div class="label horizontal layout">
          <div
            v-for="(item, index) in options"
            :key="index"
            class="flex label-option"
          >
            {{ item.title }}
          </div>
        </div>

        <Loading v-if="!isLoaded" />
      </div>
    </div>
    <CanvasQuestionImage v-show="!_isShowChart()" />
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import filterProfaneWords from 'storybook-utils/profanity-filter/filterProfaneWords'
import CanvasQuestionImage from '@/components-v2/presentation-editor/middle/CanvasQuestionImage.vue'
import Constant from '@/constant'
import Util from '@/util'
import Socket from '@/socket'
import Config from '@/config'
import Loading from '@/components/Loading'
import EventBus from '@/eventBus'
import gaCategories from '@/constant/gaCategories'

// api
import SlideApi from '@/api/slide'

export default {
  components: {
    Loading,
    CanvasQuestionImage,
  },
  data() {
    return {
      options: [],
      isLoaded: false,
      hoveringColumnId: null,
    }
  },
  computed: {
    ...mapGetters(['isBackstage', 'isPresenting']),
    ...mapState({
      slideActive: (state) => state.slideActive,
      sharePresentation: (state) => state.sharePresentation,
    }),
  },
  watch: {
    '$store.state.slideActive': function watchSlideActive() {
      if (this.$store.getters.isPresenting) {
        if (this.$store.state.sharePresentation) {
          return
        }
        if (this.$store.state.slideActive.quizStatus < Constant.QuizStatuses.QUESTION_SCREEN) {
          this.options = []
        }
      }
    },
    '$store.state.presentation.filteringProfanity': function watchFilteringProfanity() {
      this.options = this.getData()
    },
  },
  created() {
    this._getDataPickAnswer()
    if (!this.$store.state.slideActive.otherCorrectQuiz) {
      this.updateSlideActiveAction({
        otherCorrectQuiz: [],
      })
    }
  },
  mounted() {
    if (this.slideActive.type === 'pickAnswer') {
      this.updateSlideActiveAction({
        addCorrectOption: true,
      })

      if (!this.isPresenting && !this.isBackstage) {
        this.updateSlideActiveAction({
          showCorrectOption: true,
          hideResult: false,
        })
      }
    }

    if (this.slideActive.type !== 'pickAnswer' || (this.slideActive.type === 'pickAnswer' && this.sharePresentation)) {
      this.$store.state.tempAudienceCount = this.slideActive.multipleCountAnswer
    }

    EventBus.$on('eventShowQuizTypeAnswer', () => {
      this.isLoaded = false
      this._getDataPickAnswer(true, true)
    })
    EventBus.$on('type-answer-no-vote: update-title', () => {
      this.isLoaded = false
      this.options = this.getData()
    })
    EventBus.$on('type-answer-no-vote: update-title-done', () => {
      this.isLoaded = true
    })
    if (this.$store.state.sharePresentation) {
      Util.disallowPDFRender()
      this.updateSlideActiveAction({
        showQuestionImage: false,
      })
    }
  },
  destroyed() {
    EventBus.$off('eventShowQuizTypeAnswer')
    EventBus.$off('type-answer-no-vote: update-title')
    EventBus.$off('type-answer-no-vote: update-title-done')
  },
  methods: {
    ...mapActions(['updateSlideActiveAction', 'setSyncLoadingAction', 'setSlideActiveAction']),
    mouseoverColumn(id) {
      this.hoveringColumnId = id
    },
    mouseLeaveColumn() {
      this.hoveringColumnId = null
    },
    opacityWhenHoverColumn(id) {
      if (!this.hoveringColumnId) {
        return 1
      }
      return (id === this.hoveringColumnId) ? 1 : 0.5
    },
    _getDataPickAnswer(showData, isTimeup) {
      if (!showData && this.$store.getters.isPresenting &&
        this.$store.state.slideActive.quizStatus < Constant.QuizStatuses.RESULT_SCREEN &&
        !this.$store.state.sharePresentation) {
        this.options = []
        this.isLoaded = true
        return
      }
      this.updateSlideActiveAction({
        showNoneOfCorrect: false,
      })

      const startTime = new Date().getTime()
      this.$http.get(Config.api.getDataQuizTypeAnswer + this.$store.state.slideActive.id)
        .then((res) => {
          const _showChart = () => {
            this.updateSlideActiveAction({
              typeAnswersData: res.body,
            })
            this.options = this.getData(true)
            this.isLoaded = true
            setTimeout(() => {
              this.options = this.getData()
              this.options.push()
            }, 300)
          }
          const endTime = new Date().getTime()
          if (isTimeup) {
            const time = 2000 - (endTime - startTime)
            if (time <= 0) {
              _showChart()
            } else {
              setTimeout(() => {
                _showChart()
              }, time)
            }
          } else {
            _showChart()
          }

          if (this.$store.state.sharePresentation) {
            Util.allowPDFRender()
          }
        }).catch((error) => {
          this.setSyncLoadingAction(3)
          if (error.body.message) {
            Util.gaTrackEvent(
              gaCategories.PRESENTATION_EDITOR,
              'Pick answer > Get chart data > Failed',
              error.body.message,
            )
          }
          throw error
        })
    },
    _showChartPercentage() {
      if (!this.sharePresentation) {
        this.updateSlideActiveAction({
          showPercentage: !this.slideActive.showPercentage,
        })

        this._updateSlide({
          accessCode: this.$store.state.presentation.uniqueAccessCode,
          showPercentage: this.$store.state.slideActive.showPercentage,
        })
      }
    },
    getData(isFirstTime) {
      let maxCount = 0
      const options = []
      const colors = JSON.parse(JSON.stringify(Constant.colors))
      const slide = this.$store.state.slideActive
      let total = 0

      let limitOption = 8
      if (slide.type === 'pickAnswer') {
        limitOption = 8
      }
      if (!slide.typeAnswersData) slide.typeAnswersData = []
      slide.typeAnswersData.forEach((item, key) => {
        if (key < limitOption) {
          if (!item.count) item.count = 0
          if (item.count > maxCount) {
            maxCount = item.count
          }
          total += item.count
          const { count } = item
          if (item.title == 'Other answers') {
            item.title = this.$t('otherAnswers')
          }
          options.push({
            count,
            title: item.title,
            color: colors[key],
            boderColor: colors[key],
            id: item.id,
            correct: item.correct,
            percent: 0,
          })
        }
      })
      let hasCorrect = false
      options.forEach((item, key) => {
        item.title =
        this.$store.state.presentation.filteringProfanity && item.title && !item.correct
          ? filterProfaneWords(item.title)
          : item.title

        if (!item.count) {
          item.countPercent = `${0}%`
        } else {
          item.countPercent = `${(item.count / maxCount) * 100}%`
          item.percent = Math.round((item.count / total) * 100 * 100) / 100
        }
        let limitText = 120
        if (options.length == 4) {
          limitText = 100
        }
        if (options.length == 5) {
          limitText = 76
        }
        if (options.length == 6) {
          limitText = 60
        }
        if (options.length == 7) {
          limitText = 50
        }
        if (options.length == 8) {
          limitText = 40
        }
        if (options.length > 2) {
          item.title = Util.truncate(item.title, limitText)
        }
        if (slide.showCorrectOption &&
          item.correct &&
          (this.$store.getters.isPresenting || this.isBackstage)
        ) {
          item.title = `✅ ${item.title}`
          if (item.count) {
            hasCorrect = true
          }
        }
        if (
          slide.showCorrectOption &&
          !item.correct && this.$store.getters.isPresenting
        ) {
          item.title = `❌ ${item.title}`
          item.color = Util.changeRgbaColor(colors[key])
          item.boderColor = Util.changeRgbaColor(colors[key])
        }

        if (slide.textColour == '#ffffff') {
          item.boderColor = '#ffffff'
        }

        if (isFirstTime) {
          item.countPercent = `${0}%`
        }
      })
      if (!hasCorrect) {
        this.updateSlideActiveAction({
          showNoneOfCorrect: true,
        })
      }
      return options
    },

    async _updateSlide(params) {
      if (
        this.$store.state.sharePresentation ||
        this.$store.state.slideActive.type === 'pickAnswer'
      ) {
        return
      }
      this.setSlideActiveAction(this.slideActive)
      params.socketId = Socket.getSocketId()
      this.setSyncLoadingAction(1)
      Util.uploadSlide(
        this.$store.state.slideActive,
        this.$store.state.presentation,
      )
      params.presenting = this.$store.getters.isPresenting

      try {
        await SlideApi.updateSlideById(this.slideActive.id, params)
        Util.gaTrackEvent(
          'Slide',
          'Edit setting',
          'Presenter edit setting show percentage on chart',
        )
        this.setSyncLoadingAction(2)
      } catch (error) {
        this.setSyncLoadingAction(3)
      }
    },

    _isShowChart() {
      const presenting = this.$store.getters.isPresenting || this.isBackstage
      const { slideActive } = this.$store.state
      const noQuestionImg = !slideActive.showQuestionImage || !slideActive.image
      if ((!presenting && noQuestionImg) ||
        (presenting && !this.$store.state.sharePresentation) ||
        (presenting && this.$store.state.sharePresentation && noQuestionImg)) {
        return true
      }
      return false
    },
  },
}
</script>
<style lang="scss" scoped>
.image-cropped-option {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  z-index: 9;
}
.image-choice-content {
  padding: 0 32px 6px 32px;
  width: 100%;
  height: 100%;
}

.box-chart,
.content-chart {
  width: 100%;
  height: 100%;

  & ::v-deep .spinner {
    width: 90px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -45px;

    & > div {
      width: 25px;
      height: 25px;
    }
  }
}
.line {
  border-top: 1px solid #313131;
  margin-bottom: 8px;
}
.label-option {
  text-align: center;
  padding: 0 8px;
  font-weight: normal;
  line-height: 1.3;
}

.h-column {
  width: 100px;
  margin: 0 auto;
  border-bottom: 0;
  position: relative;
  cursor: pointer;
  min-height: 4px;
  transition: 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);

  &:hover {
    opacity: 0.9;
  }
}
.content-column {
  width: 100%;
  height: 100%;
  border: 1px solid #fff;
  border-bottom: 0;
  &.no-border {
    border: none;
  }
}
.column-option {
  position: relative;
  padding-top: 88px;
  transition: 0.5s ease-in-out;

  .value-column {
    height: 40px;
    width: 100%;
    font-size: 23px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -40px;
    left: 0;
  }
}

.column-2,
.column-1,
.column-3,
.column-4,
.column-5,
.column-6 {
  .h-column {
    width: 120px;
  }
}

.column-8,
.column-7 {
  .h-column {
    width: 116px;
  }
}
.chart-white {
  .line {
    border-color: #fff;
    overflow: hidden;
  }
}

//Set font size (same as bar chart)
.column-1,
.column-2,
.column-3 {
  .label-option {
    font-size: 26px;
  }
}

.column-4 .label-option {
  font-size: 22px;
}

.column-5,
.column-6,
.column-7,
.column-8 {
  .label-option {
    font-size: 19px;
  }
}

.column-5 {
  .label-option {
    max-width: 20%;
    word-break: break-word;
  }
}
.column-4 {
  .label-option {
    max-width: 25%;
    word-break: break-word;
  }
}

.column-3 {
  .label-option {
    max-width: 33%;
    word-break: break-word;
  }
}

.column-2 {
  .label-option {
    max-width: 50%;
    word-break: break-word;
  }
}

.column-1 {
  .label-option {
    word-break: break-word;
  }
}
</style>
